import { Row, Table } from '@tanstack/react-table';
import { CustomCellType, TableColumn } from './../models';
import { constructQueryParams } from '../../../../utils';
import { defaultsDeep } from 'lodash';

export const getCellRendererProps = (
  cellTemplateType: CustomCellType | undefined,
  row: Row<TableColumn>,
  value: unknown,
  table: Table<TableColumn>,
  props?: { [k: string]: unknown },
): { [k: string]: unknown } => {
  let cellTemplateProps = props ?? {};

  switch (cellTemplateType) {
    case CustomCellType.LINK: {
      cellTemplateProps = {
        ...cellTemplateProps,
        path: cellTemplateProps.path
          ? `${cellTemplateProps.path}${constructQueryParams(cellTemplateProps.queryParams ?? {})}`
          : '',
        ...(row.getValue('Id') == null
          ? {}
          : {
              id: row.getValue('Id'),
            }),
      };
      break;
    }
    case CustomCellType.SPARKLINE: {
      cellTemplateProps = {
        ...cellTemplateProps,
        data: (value as { timestamp: string; value: number }[]).map(({ timestamp, value }) => [
          Date.parse(timestamp),
          value,
        ]),
        ...(typeof cellTemplateProps.summaryValueColumn === 'string' &&
        row.getValue(cellTemplateProps.summaryValueColumn)
          ? {
              summaryValue: row.getValue(cellTemplateProps.summaryValueColumn),
            }
          : {}),
        // add xAxis.min and xAxis.max calculated from metadata; can be overridden by props as well
        // if null or not specified, Highcharts automatically calculates min and max based on data
        highchartsConfig: defaultsDeep({}, cellTemplateProps?.highchartsConfig ?? {}, {
          xAxis: {
            min: table?.options?.meta?.since,
            max: table?.options?.meta?.until,
          },
        }),
      };
      break;
    }
  }

  cellTemplateProps = {
    ...cellTemplateProps,
    row,
    value,
    table,
  };

  return cellTemplateProps;
};
